import { render, staticRenderFns } from "./belonger.vue?vue&type=template&id=f888810a&scoped=true&"
import script from "./belonger.vue?vue&type=script&lang=js&"
export * from "./belonger.vue?vue&type=script&lang=js&"
import style0 from "./belonger.vue?vue&type=style&index=0&id=f888810a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f888810a",
  null
  
)

export default component.exports